import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Word} from '../../_models';
import {WordService} from '../../_services/word.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-delete-word',
  templateUrl: './delete-word.component.html',
  styleUrls: ['./delete-word.component.scss']
})
export class DeleteWordComponent {

  @Output() refreshEvent = new EventEmitter<string>();
  @Input() word: Word;

  constructor(private wordService: WordService) { }

  delete() {

    this.wordService.delete(this.word.id).pipe(first()).subscribe(result => {
        this.refreshEvent.emit();
    });
  }

  close() {
    this.refreshEvent.emit();
  }

}
